module.exports = __webpack_public_path__ + "media/images/oauth/bigcommerce_us-9a21a7d5e04376fa97d264dab21a3d0a.png";